<template>
  <div>
    <std-opt
      v-if="!passOnly"
      v-model="authData.auth_type"
      :prop="prop('auth_type')"
      :disabled="disabledType"
      name="authType"
      data="auth_type"
      ref="authTypeOpts"
      >
    </std-opt>
    <el-form-item
      v-if="idOnly"
      :label="$t('api.user.authIDOri')"
      prop="ori_auth_id"
      >
      <el-input
        v-model="authData.ori_auth_id"
        type="email"
        class="form-item"
        disabled
        >
      </el-input>
    </el-form-item>
    <el-form-item
      v-if="!passOnly"
      :label="idOnly ? $t('api.user.authIDNew') : $t('api.user.authID')"
      :prop="prop('auth_id')"
      :rules="getAuthIdRules(authData.auth_type)"
      >
      <el-input
        v-model="authData.auth_id"
        type="email"
        class="form-item"
        maxlength="128"
        :placeholder="authIdPlaceholder(authData.auth_type)"
        :disabled="isEdit"
        clearable
        >
      </el-input>
      <el-button
        type="text"
        v-if="isEdit"
        @click="clickEditAuthId(authData.id, authData.auth_type, authData.auth_id)"
        >
        {{ $t('api.user.editAuthIdBtn') }}
      </el-button>
    </el-form-item>
    <password-input
      v-if="isShowPassword"
      :base="base"
      :formRef="formRef"
      :passData="authData"
      :needOriginPass="needOriginPass"
      >
    </password-input>
    <el-form-item
      v-if="isEdit && isPassword(authData.auth_type)"
      :label="$t('api.user.pass')"
      >
      <el-button
        type="text"
        @click="clickEditAuthToken(authData.id)"
        >
        {{ $t('api.user.editPassBtn') }}
      </el-button>
    </el-form-item>
    <el-form-item
      v-if="!idOnly && !isEdit && isToken(authData.auth_type)"
      :label="$t('api.user.authToken')"
      :prop="prop('auth_token')"
      :rules="authTokenRules"
      >
      <el-input
        v-model="authData.auth_token"
        class="form-item"
        :placeholder="$t('api.user.error.auth_token')"
        auto-complete="off"
        clearable
        >
      </el-input>
    </el-form-item>
  </div>
</template>

<script>

const defData = {
  id: undefined,
  auth_type: 0,
  auth_id: '',
  auth_token: '',
  auth_token_c: '',
  ori_pass: '',
  created_at: undefined,
  updated_at: undefined
}

export default {
  components: {
  },
  name: 'auth-input',
  props: {
    base: {
      type: String,
      default: ''
    },
    disabledType: {
      type: Boolean,
      default: true
    },
    idOnly: {
      type: Boolean,
      default: false
    },
    passOnly: {
      type: Boolean,
      default: false
    },
    needOriginPass: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    formRef: {
      type: Object,
      default: () => {}
    },
    formData: {
      type: Object,
      default: () => {}
    },
    editAuthId: {
      type: Function,
      default: () => {}
    },
    editAuthToken: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      prop: (name) => {
        return this.base === '' ? name : (this.base + '.' + name)
      },
      authEmailRules: [
        {
          required: true,
          message: this.$t('api.user.error.auth_id'),
          trigger: 'blur'
        },
        {
          type: 'email',
          message: this.$t('api.user.error.auth_id_email'),
          trigger: 'blur'
        }
      ],
      authIdRules: [
        {
          required: true,
          message: this.$t('api.user.error.auth_id'),
          trigger: 'blur'
        }
      ],
      authTokenRules: [
        {
          required: true,
          message: this.$t('api.user.error.auth_token'),
          trigger: 'blur'
        }
      ],
      authData: this.formData || Object.assign({}, defData),
      authIdPlaceholder: (authType) => {
        if (authType === 0) {
          return this.$t('api.user.placeholder.auth_id_email')
        }
        return this.$t('api.user.placeholder.auth_id')
      }
    }
  },
  computed: {
    isShowPassword () {
      return !this.idOnly && !this.isEdit && this.isPassword(this.authData.auth_type)
    }
  },
  mounted () {
  },
  methods: {
    updOptDisabled (val, disabled) {
      return this.$refs.authTypeOpts.updOptDisabled(val, disabled)
    },
    getAuthIdRules (authType) {
      if (!this.isEdit) {
        switch (authType) {
          case 0:
          case 1:
            return this.authEmailRules
        }
        return this.authIdRules
      }
      return []
    },
    isToken (authType) {
      switch (authType) {
        case 2:
          return true
        case 0:
        case 1:
        case 3:
          return false
      }
      return this.passOnly
    },
    isPassword (authType) {
      switch (authType) {
        case 0:
          return true
        case 1:
        case 2:
        case 3:
          return false
      }
      return this.passOnly
    },
    clickEditAuthId (id, authType, authId) {
      this.editAuthId(id, authType, authId)
    },
    clickEditAuthToken (id) {
      this.editAuthToken(id)
    }
  },
  watch: {
    formData (data) {
      this.authData = data
    },
    'authData.auth_type' (t) {
      var e = this.formRef || this.$parent
      if (typeof e.clearValidate === 'function') {
        e.clearValidate()
      }
    }
  }
}
</script>
